import "core-js/stable";
import "regenerator-runtime/runtime";
import 'es6-promise/auto'
import 'classlist-polyfill'

require('./bootstrap');
require('./bootstrap-marxism.js');
require('./request-animation-frame-polyfill');

import Vue from 'vue';
import VueRouter from 'vue-router';
import utils from './utils';
import AOS from 'aos';
import smoothscroll from "smoothscroll-polyfill";

window.Vue = Vue;

Vue.use(VueRouter);
Vue.component('Modal', require('./components/client/Modal').default);
Vue.component('Profile', require('./components/client/Profile').default);
Vue.component('Profiles', require('./components/client/Profiles').default);
Vue.component('Topic', require('./components/client/Topic').default);
Vue.component('topic-title', require('./components/client/TopicTitle').default);
Vue.component('TopicCategory', require('./components/client/TopicCategory').default);
Vue.component('PageList', require('./components/client/PageList').default);
Vue.component('Page', require('./components/client/Page').default);
Vue.component('check-ticket', require('./components/client/CheckTicket').default);
Vue.component('register-form', require('./components/client/RegisterForm').default);
Vue.component('donation-form', require('./components/client/DonationForm').default);
Vue.component('qna-form', require('./components/client/QnaForm').default);
Vue.component('topics', require('./components/client/Topics').default);


const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			name: 'topic-category',
			path: '/topic-category/:id',
			component: Vue.component('TopicCategory'),
			props: route => ({
                marxism: marxism,
				topicCategory: marxism.topicCategories.find(c => c.id == route.params.id)
			})
		},
		{
			name: 'topic',
			path: "/topic/:id",
			component: Vue.component("Topic"),
			props: route => ({
                marxism: marxism,
				topic: marxism.topics[route.params.id]
			})
		},
		{
			name: 'profile',
			path: "/profile/:id",
			component: Vue.component("Profile"),
			props: route => ({
				marxism: marxism,
				profile: marxism.profiles[route.params.id]
			})
		},
		{
			name: 'profiles',
			path: "/profiles",
			component: Vue.component("Profiles"),
			props: route => ({
				marxism: marxism,
				profiles: marxism.defaultProfiles
			})
		},
		{
			name: 'pageList',
			path: "/page-list/:category",
			component: Vue.component("PageList"),
			props: route => route.params
		},
        {
            name: 'page',
            path: '/page/:id',
            component: Vue.component('Page'),
            props: route => ({
                id: route.params.id,
                marxism: marxism
            })
        },
		{
            name: 'check-ticket',
            path: '/check-ticket',
            component: Vue.component('check-ticket'),
            props: route => ({
                marxism: marxism
            })
        },
        {
            name: 'topics',
            path: '/topics',
            component: Vue.component('topics'),
            props: route => ({
                marxism: marxism,
                topics: marxism.topics,
                topicCategories: marxism.topicCategories,
            })
        }
	]
});

router.afterEach((to, from) => {
	Vue.nextTick(() => {
		if (to.name) {
			vm.showModal = true;
		} else {
			vm.showModal = false;
		}
	});
});


const vm = new Vue({
	el: '#app',
	router,
	data: {
		locationHash: window.location.hash,
		showModal: false,
		email: '',
		output: '',
        showMoreSpeaker: false,
        selectedCurrentTimetableDate: null,

        topicsByDate: marxism.topicsByDate,
	},
    mixins: [require('./mixin/header.mixin'), require('./mixin/helper.mixin')],
	methods: {
	    toHome() {
	        this.$router.push('/');
	        document.querySelector('title').innerText = `${window.marxism.title} - 마르크스주의 포럼`;
        },
        gtagPageView(title, path) {
	        if (window.gtag) {
                window.gtag('config', 'UA-2193909-1', {
                    'page_title': title,
                    'page_path': path,
                });
            }
        },
		openRegisterFormSection() {
			const registerFormSection = $('#register-form');
			registerFormSection.classList.remove('u-hidden');

			window.scrollTo({
				top: registerFormSection.offsetTop,
				left: 0,
				behavior: 'smooth'
			});

			setTimeout(() => {
				let currentContainer = Array
					.from(registerFormSection.querySelectorAll('.js-step-container'))
					.filter(el => el.style.display !== 'none')
					[0];
				currentContainer.querySelector('input').focus();
			}, 1000);

            this.gtagPageView("참가신청 폼", '/#register-form');

		},

        openDonationFormSection() {
            const donationFormSection = $('#donation-form');
            donationFormSection.classList.remove('u-hidden');

            window.scrollTo({
                top: donationFormSection.offsetTop,
                left: 0,
                behavior: 'smooth'
            });

            setTimeout(() => {
                donationFormSection.querySelector('[name="name"]').focus();
            }, 1000);

            this.gtagPageView("후원하기 폼", '/#donation-form');

        },

        openQnaFormSection() {
            const qnaSection = $('#qna');
            qnaSection.classList.remove('u-hidden');

            window.scrollTo({
                top: qnaSection.offsetTop,
                left: 0,
                behavior: 'smooth'
            });

            setTimeout(() => {
                qnaSection.querySelector('[name="name"]').focus();
            }, 1000);

            this.gtagPageView("문의", '/#qna');

        },

		openRegisterMailSection() {
			const registerMailSection = $('.register-mail');
			const el = $('#register-mail-form');
			registerMailSection.classList.remove('u-hidden');
			el.focus();
            this.gtagPageView("메일로 소식받기", '/#register-mail-form');
		},

		registerMail: function () {
			axios.post('/register-mail', {
				email: this.email
			})
				.then(function (response) {
					const text = response.data.message;

					if (response.data.result === 'fail') {

						swal({
							icon: 'warning',
							text: text
						})
					} else if (response.data.result === 'success') {
						swal({
							icon: 'success',
							text: text
						});
					}
				})
		},
		cancelMail: function () {
			axios.post('/cancel-mail', {
				email: this.email
			})
				.then(function (response) {
					const text = response.data.message;
					if (response.data.result === 'success') {
						swal({
							icon: 'success',
							text: text
						})

					} else if (response.data.result === 'error') {
						swal({
							icon: 'error',
							text: text
						})
					}
				});
		},
        showTimetableByDate(date) {
            this.selectedCurrentTimetableDate = date;
            const top = document.getElementById('timetable-table-start-line').offsetTop - 60;
            setTimeout(() => {
                window.scrollTo({
                    top: top,
                    behavior: "smooth"
                });
            }, 200);
            if (window.gtag) {
                this.gtagPageView(`시간표-${date}`, `/#timetable-${date}`)
            }
        }
	},
    computed: {
        currentTimetableDate() {
            if (this.selectedCurrentTimetableDate) {
                return this.selectedCurrentTimetableDate;
            }
            const today = moment();
            const startDate = moment(marxism.startDate);
            const endDate = moment(marxism.endDate);
            if (today.isSameOrAfter(startDate) && today.isSameOrBefore(endDate)) {
                return today.format('YYYYMMDD');
            } else {
                return startDate.format('YYYYMMDD');
            }
        }
    },
	created() {
		// 이 데이터는 불변하므로 쌍방향 바인딩을 하지 않는다.
		this.marxism = marxism;
		this.utils = utils;
		this.pUrl = 'https://p.marxism.or.kr';

		if ("MutationObserver" in window) {
			// 스크롤하면 애니메이션 효과
			// MutationObserver 기능이 필요하다.
			AOS.init({
				duration: 1000,
				once: true
			});
		} else {

			// IE10 이하는 MutationObserver 기능이 없다.
			document.querySelectorAll('[data-aos]').forEach(el => {
				el.removeAttribute('data-aos');
			})
		}
	},
	mounted() {

		new Swiper(document.getElementById('top-slider'), {
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			on: {
				init() {
					document.getElementById('js-index-slide-text').classList.remove('u-hidden');
					document.getElementById('js-index-slide-button').classList.remove('u-hidden');
					document.getElementById('js-index-slide-text').classList.add('bounceInDown');
					document.getElementById('js-index-slide-button').classList.add('bounceInDown');
				},
                slideChange() {
				    // 정방향 주행은 +2까지 미리 다운로드
				    const nextSlide = document.querySelector(`.swiper-slide:nth-child(${this.activeIndex + 2})`);
				    if (nextSlide && nextSlide.classList.contains('c-index-slide-placeholder')) {
				        const className = nextSlide.dataset['class'];
                        nextSlide.classList.remove('c-index-slide-placeholder');
                        nextSlide.classList.add(className);
                    }

				    // 역방향 주행은 역방향 이동하는 경우 지금 나오는 슬라이드만 받는다.
                    const activeSlide = document.querySelector(`[data-swiper-slide-index="${this.realIndex}"]`);
                    if (activeSlide && activeSlide.classList.contains('c-index-slide-placeholder')) {
                        const className = activeSlide.dataset['class'];
                        activeSlide.classList.remove('c-index-slide-placeholder');
                        activeSlide.classList.add(className);
                    }

				    if (window.gtag) {
                        gtag('event', 'view_slide', {
                            'event_label': `slide to ${this.realIndex}`,
                            'event_category': 'change_slide',
                            'non_interaction': true
                        });

                    }
                },
				slideChangeTransitionStart() {
					document.getElementById('js-index-slide-text').classList.remove('bounceInDown');
					document.getElementById('js-index-slide-button').classList.remove('bounceInDown');
					document.getElementById('js-index-slide-text').classList.add('bounceOutDown');
					document.getElementById('js-index-slide-button').classList.add('bounceOutDown');
				},
				slideChangeTransitionEnd() {
					document.getElementById('js-index-slide-text').classList.add('bounceInDown');
					document.getElementById('js-index-slide-button').classList.add('bounceInDown');
					document.getElementById('js-index-slide-text').classList.remove('bounceOutDown');
					document.getElementById('js-index-slide-button').classList.remove('bounceOutDown');
					document.getElementById('js-index-slide-text').innerHTML = marxism.slides[this.realIndex].text;
				}
			}
		});


		// for ie and safari not support css scroll-behavior property.
		if (!("scroll-behavior" in document.documentElement.style)) {

			// kick off the polyfill!
			smoothscroll.polyfill();

			document.querySelectorAll('a[href^="#"]').forEach(el => {
				el.addEventListener('click', function (e) {
					const targetId = e.currentTarget.href.split('#')[1];
					const targetEl = document.getElementById(targetId);
					if (targetEl) {
						e.preventDefault();
						window.scroll({
							top: targetEl.offsetTop,
							left: 0,
							behavior: 'smooth'
						});

						// 시각장애인을 위한 것. 포커스를 옮겨 줘야 한다.
						setTimeout(() => {
							location.href = '#' + targetId;
						}, 500);
					}
				})
			});

		}

		if (this.locationHash) {
			setTimeout(() => {
                window.scrollTo({
                    top: $(this.locationHash).offsetTop,
                    left: 0,
                    behavior: "smooth"
                });
            }, 1000);
		}
	}
});

window.vm = vm;


if (window.gtag) {
    // # 앵커 추적.
    document.querySelectorAll('[href^="#"]').forEach(el => {
        el.addEventListener('click', e => {
            let pageTitle = e.currentTarget.innerText || e.currentTarget.querySelector('img').alt || el.href;
            pageTitle += ` | ${marxism.title} - 마르크스주의 포럼`;
            let pagePath = el.href.replace((new URL(el.href)).origin, '');
            window.gtag('config', 'UA-2193909-1', {
                'page_title': pageTitle,
                'page_path': pagePath,
            });
        });
    });
}
